import { Link } from 'react-router-dom';
function Header() {
  return (
    <div className="header">
      <div className="container">
        <h1>
          <Link to="/">
            홈으로
          </Link>
        </h1>
        <ul>
          <li>
            <Link to="/company">
              회사소개
            </Link>
          </li>
          <li>
            <Link to="/business">
              비즈니스
            </Link>
          </li>
          <li>
            <Link to="/solution">
              솔루션
            </Link>
          </li>
          {/* <li>
            <Link to="/careers">
              인재채용
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
}
export default Header;